import useAppSelector from 'hooks/useAppSelector';
import { selectTeaserInfo } from 'store/reducers/shopSlice';
import styled from 'styled-components/macro';
import { ensureAbsoluteUrl } from 'utils/url';
import HomePageSection from './HomePageSection';

export const Teaser = () => {
    const teaserInfo = useAppSelector(selectTeaserInfo);
    if (!teaserInfo?.teaserImageUrl) return null;

    return (
        <HomePageSection spacing="lg">
            <TeaserWrapper $imageUrl={teaserInfo.teaserImageUrl}>
                <TeaserContent $textColor={teaserInfo.teaserTextColor ?? undefined}>
                    {teaserInfo.teaserSubTitle && <SubTitle>{teaserInfo.teaserSubTitle}</SubTitle>}
                    {teaserInfo.teaserTitle && <Title>{teaserInfo.teaserTitle}</Title>}
                    {teaserInfo.teaserText &&
                        (teaserInfo.teaserUrl ? (
                            <TextLink href={ensureAbsoluteUrl(teaserInfo.teaserUrl)}>{teaserInfo.teaserText}</TextLink>
                        ) : (
                            <Text>{teaserInfo.teaserText}</Text>
                        ))}
                </TeaserContent>
            </TeaserWrapper>
        </HomePageSection>
    );
};

const TeaserWrapper = styled.div<{ $imageUrl: string }>`
    width: 100%;
    min-height: 300px;
    height: 580px;
    border-radius: 16px;
    background-image: url(${({ $imageUrl }) => $imageUrl});
    background-size: cover;
    background-position: center;
    display: flex;
    align-items: center;
    justify-content: flex-start;

    ${({ theme }) => theme.media.mdBelow} {
        justify-content: center;
        min-height: 260px;
    }
`;

const TeaserContent = styled.div<{ $textColor?: string }>`
    padding: 40px 48px;
    max-width: 50%;
    text-align: left;
    ${({ $textColor }) => $textColor && `color: ${$textColor};`}

    ${({ theme }) => theme.media.mdBelow} {
        max-width: 90%;
        text-align: center;
        padding: 32px 24px;
    }
`;

const SubTitle = styled.span`
    display: block;
    font-size: 12px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    margin-bottom: 8px;
`;

const Title = styled.h2`
    font-size: 2rem;
    font-weight: 700;
    margin-bottom: 12px;
    line-height: 1.2;
`;

const Text = styled.p`
    font-size: 1rem;
    font-weight: 500;
    margin-bottom: 8px;
    line-height: 1.5;
`;

const TextLink = styled.a`
    font-size: 1rem;
    font-weight: 500;
    margin-bottom: 8px;
    line-height: 1.5;
    color: inherit;
    text-decoration: none;

    &:hover {
        color: inherit;
        opacity: 0.8;
    }
`;

export default Teaser;
